<template>

    <div class="w-full">

        <div class="w-full text-center" v-if="loading">
            <div class="py-5" colspan="4">
                <h1 class="text-xl"><i class="fa fa-circle-notch fa-spin"></i></h1>
            </div>
        </div>

        <div class="bg-white rounded-lg shadow p-6 mb-6" v-for="video in videos">
            <h3 class="text-xl font-semibold pb-3 border-b-2 border-grey-lighter mb-4">
                <span class="bg-blue-700 px-2 py-1 rounded text-white text-sm mr-2">${{ video.price }}</span>
                {{ video.title }}
                <span class="float-none mt-2 block md:float-right md:mt-0 md:inline-block" :title="video.created_at | displayLocalDateTime" v-tippy>{{ video.created_at | timeAgo }}</span>
            </h3>

            <div class="flex items-center bg-red-700 text-white text-sm font-bold px-4 py-3 mb-4" role="alert" v-if="video.embargo !== null">
                <p><i class="fas fa-exclamation-triangle mr-2"></i> There is an embargo for this video in the <strong>{{ video.embargo }}</strong> market.</p>
            </div>

            <div class="flex items-center bg-blue-700 text-white text-sm font-bold px-4 py-3 mb-4" role="alert" v-if="video.purchased">
                <p><i class="fas fa-box-check mr-2"></i> A member of your network has already purchased this video. You may download the video again, if needed, without repurchasing.</p>
                <div class="flex-1 text-right">
                    <button class="bg-white text-black rounded px-3 py-1" v-on:click="downloadVideo(video.id)">
                        Download Video
                    </button>
                </div>
            </div>

            <div class="flex flex-wrap">
                <div class="w-full md:w-1/2 lg:w-1/3 text-center">
                    <YouTubePlayer :youtube_id="video.youtube_id" />
                    <a :href="'https://youtube.com/watch?v=' + video.youtube_id" class="text-blue-600" target="_blank">https://youtube.com/watch?v={{ video.youtube_id }}</a>
                </div>
                <div class="w-full md:w-1/2 lg:w-2/3 md:pl-5">
                    <p v-if="video.rating !== null"><strong>Rating: </strong> <StarRating :id="video.id" :rating="video.rating" /></p>
                    <p><strong>Credit: </strong> {{ video.user_credit }} / Viral News</p>
                    <p><strong>Description: </strong><br /> {{ video.description }}</p>
                    <p v-if="video.locations.length !== undefined && video.locations.length !== 0"><strong>Locations: </strong><br /> <span class="rounded px-2 py-1 bg-green-500 text-white text-xs mr-2" v-for="location in video.locations">{{ location }}</span></p>
                </div>
            </div>

            <div class="w-full text-right" v-if="!video.purchased || video.purchased == null">
                <button class="px-3 py-1 bg-blue-700 text-white rounded w-full md:w-auto mt-5 md:mt-0" v-on:click="purchase(video)">Purchase and Download Video</button>
            </div>

        </div>

    </div>

</template>

<script>

    import { EventBus } from '../../utils/events';
    import * as Config from '../../config'
    import { mapState, mapGetters } from 'vuex';
    import moment from 'moment';
    import YouTubePlayer from './components/YouTubePlayer'
    import StarRating from '@/components/general/StarRating'

	export default {
		name: 'MediaLatestUploaded',
		data () {
			return {
                videos: {},
                chasersCount: 0,
                interval: null,
                lastUpdate: null,
                loading: true,
			}
        },
        components: {
            YouTubePlayer,
            StarRating
		},
        mounted() {
            this.getVideos();
            this.lastUpdate = Date.now();

            this.$nextTick(function () {
                EventBus.$on('media-video-refresh-data', this.getVideos);
                EventBus.$on('media-updated-chasers', this.updateChaserCount);
            }.bind(this));

            this.interval = setInterval(function () {
                this.getVideos();
                this.lastUpdate = Date.now();
            }.bind(this), 30000);
        },
        methods: {
            ...mapGetters([
                'getAuthorizationHeader',
            ]),
            getVideos() {
                var _this = this;
                this.$http.get(Config.apiPath + "/api/v2/media/latest", this.getAuthorizationHeader()).then((response) => {
                    this.$set(this, 'videos', response.data)
                    this.$set(this, 'loading', false)
                });
            },
            viewVideoModal(video) {
                EventBus.$emit('media-view-video-open-modal', video);
            },
            updateChaserCount(count) {
                this.chasersCount = count;
            },
            displayLocalDateTime(date) {
                return moment.utc(date).local().format('MMMM Do YYYY, h:mm:ss a');
            },
            purchase(video) {

                var _this = this;

                this.$swal({
                    title: 'Continue?',
                    text: "You are about to purchase " + video.title + " for $" + video.price + ".",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, purchase and download.'
                }).then((result) => {

                    if (result.value) {

                        var data = {
                            id: video.id,
                        }

                        this.$http.post(Config.apiPath + "/api/v2/media/purchases/new", data, this.getAuthorizationHeader())
                            .then((response) => {
                                
                                var link = document.createElement('a');
                                document.body.appendChild(link);
                                link.href = response.data;
                                link.click();
                                document.body.removeChild(link);

                                _this.$swal(
                                    'All good!',
                                    'The video download has started.',
                                    'success'
                                )

                            });
                    }

                });

            },
            downloadVideo(id) {
                var self = this;
                this.$http.get(Config.apiPath + "/api/v2/media/purchases/download/" + id, this.getAuthorizationHeader())
                    .then((response) => {
                        if(response.data !== 400) {
                            var link = document.createElement('a');
                            document.body.appendChild(link);
                            link.href = response.data;
                            link.click();
                            document.body.removeChild(link);
                        } else {
                            self.$swal(
                                'Uh oh!',
                                'There has been an issue. It looks like you don\'t own this video. If this is a mistake, please open a support ticket or contact Brett Adair.',
                                'error'
                            )
                        }
                    });
            }
        },
        beforeDestroy: function() {
            clearInterval(this.interval);
        },
        filters: {
            timeAgo: function(date) {
                return moment.utc(date).fromNow();
            },
            timecode: function(value) {
                if(value !== null) {
                    var seconds = Math.floor( value % 60 ).toString();
                    var minutes = Math.floor( value / 60 ).toString();
                    if( seconds.length === 1 ){
                        seconds = '0' + seconds;
                    }                
                    return minutes + ':' + seconds;
                }
            },
            displayLocalDateTime: function(date) {
                return moment.utc(date).local().format('MMMM Do YYYY, h:mm a');
            }
        }
	}
</script>

<style scoped>

    .filter {
        background-color: #fff;
        border-radius: 6px;
        min-height: 20px;
        width: 100%;
        height: auto;
    }

    .max-w-200 {
        max-width: 200px;
        height: auto;
    }

    .last-update {
        font-size: 16px;
    }

    .text-transform-none {
        text-transform: none;
    }

</style>
